var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fade"}),_c('div',{staticClass:"Modal"},[_c('img',{attrs:{"src":require("./close.png")}}),_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Fechar")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }